export class ReferenceEventRequest {
    id: string;
    layout: string;
    flow: string;
}
